import PageMeta from "../components/common/PageMeta";
import PageContainer from "../components/common/PageContainer";
import PageHeader from "../components/common/PageHeader";
import CrmConnectorPaymentsCoverage from "../components/dashboard/CrmConnectorPaymentsCoverage";

export default function CrmConnectorTransactionsPage() {
  return (
    <div>
      <PageMeta
        title="Chargemont | CRM Connector Transactions"
        description="CRM connector transactions coverage and import status"
      />
      <PageContainer>
        <PageHeader title="CRM Connector Transactions" />
        <CrmConnectorPaymentsCoverage />
      </PageContainer>
    </div>
  );
}
